import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "result", "saveButton", "clearButton"]
  static values = { url: String, paramName: { type: String, default: "policy_draft[custom_domain]" } }

  connect() {
    this.updateButtonState()
    // If domain is already saved, show clear button
    if (this.inputTarget.value.trim().length > 0 && this.resultTarget.querySelector('.bg-green-50')) {
      this.saveButtonTarget.textContent = "Saved"
      if (this.hasClearButtonTarget) {
        this.clearButtonTarget.classList.remove("hidden")
      }
    }
  }

  inputChanged() {
    this.updateButtonState()
    // Reset button text when user types
    this.saveButtonTarget.textContent = "Save"
  }

  updateButtonState() {
    const hasValue = this.inputTarget.value.trim().length > 0
    this.saveButtonTarget.disabled = !hasValue
  }

  async save(event) {
    event.preventDefault()

    const domain = this.inputTarget.value.trim()
    this.saveButtonTarget.disabled = true
    this.saveButtonTarget.textContent = "Saving..."

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "Accept": "text/html",
          "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
        },
        body: new URLSearchParams({
          [this.paramNameValue]: domain
        })
      })

      if (response.ok) {
        const html = await response.text()
        this.resultTarget.innerHTML = html
        this.saveButtonTarget.textContent = "Saved"

        // Keep the input in sync and show clear button
        if (domain) {
          this.inputTarget.value = domain
          if (this.hasClearButtonTarget) {
            this.clearButtonTarget.classList.remove("hidden")
          }
        }
      } else {
        this.resultTarget.innerHTML = '<p class="text-sm text-red-600">Failed to save. Please try again.</p>'
        this.saveButtonTarget.textContent = "Save"
        this.saveButtonTarget.disabled = false
      }
    } catch (error) {
      this.resultTarget.innerHTML = '<p class="text-sm text-red-600">Network error. Please try again.</p>'
      this.saveButtonTarget.textContent = "Save"
      this.saveButtonTarget.disabled = false
    }
  }

  async clear(event) {
    event.preventDefault()

    this.inputTarget.value = ""
    this.updateButtonState()

    try {
      await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "Accept": "text/html",
          "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
        },
        body: new URLSearchParams({
          [this.paramNameValue]: ""
        })
      })

      this.resultTarget.innerHTML = ""
      this.saveButtonTarget.textContent = "Save"
      if (this.hasClearButtonTarget) {
        this.clearButtonTarget.classList.add("hidden")
      }
    } catch (error) {
      // Silent fail on clear
    }
  }
}
